<i18n
  src="@/locales/views/agro_exporter/certifications/query_providers/show_packing_house.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/packing_house_certification.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_providers')"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  ></go-back-link>
  <bread-crumbs :labels="[module_name, packing_house?.name]"></bread-crumbs>
  <template v-if="load_data_general">
    <div class="flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="
            packing_house_certifications.length +
            ' ' +
            $t('labels.total_number_packing_house_certifications')
          "
        />
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <alert-danger :errors_data="std_err" />
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t("model.packing_house_certification.certification_id")
                    }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t("model.packing_house_certification.certification_code")
                    }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.packing_house_certification.renewal_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{
                      $t("model.packing_house_certification.expiration_date")
                    }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.packing_house_certification.active") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.packing_house_certification.expired_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="packing_house_certification in packing_house_certifications"
                  :key="packing_house_certification.id"
                >
                  <td class="table-cell">
                    {{ packing_house_certification.certification.name }}
                  </td>
                  <td class="table-cell">
                    {{ packing_house_certification.certification_code }}
                  </td>
                  <td class="table-cell">
                    {{
                      dateFormatter(packing_house_certification.renewal_date)
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      dateFormatter(packing_house_certification.expiration_date)
                    }}
                  </td>
                  <td class="table-cell">
                    <yes-no-label :value="packing_house_certification.active" />
                  </td>
                  <td class="table-cell">
                    <div
                      v-if="packing_house_certification.active"
                      v-html="expiredAt(packing_house_certification)"
                    ></div>
                  </td>
                  <td class="table-cell">
                    <template
                      v-if="packing_house_certification.certificate_filename"
                    >
                      <i
                        :class="[
                          'cursor-pointer fa-solid',
                          packing_house_certification.downloading_certificate
                            ? 'fa-sync fa-spin'
                            : 'fa-download'
                        ]"
                        @click.prevent="
                          downloadCertificateFile(packing_house_certification)
                        "
                      ></i>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/certifications/query_providers/list_certifications.js";

export default {
  name: "ShowPackingHouse",
  data() {
    return {
      load_data_general: false,
      proc_button_destroy: false,
      packing_house: {},
      packing_house_certifications: []
    };
  },
  props: {
    agro_exporter_id: { required: true },
    packing_house_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    async loadData() {
      await this.fetchPackingHouse();
      await this.fetchPackingHouseCertifications();
      this.load_data_general = true;
    },
    async fetchPackingHouse() {
      let response = await Requester.fetchPackingHouse(
        this.agro_exporter_id,
        this.packing_house_id
      );

      this.packing_house = response.data;
    },
    async fetchPackingHouseCertifications() {
      let response = await Requester.fetchPackingHouseCertifications(
        this.agro_exporter_id,
        this.packing_house_id
      );

      this.packing_house_certifications = response.data;
      this.packing_house_certifications.forEach(org_certif => {
        org_certif["downloading_certificate"] = false;
      });
    },
    async downloadCertificateFile(packing_house_certification) {
      packing_house_certification.downloading_certificate = true;
      try {
        var response = await Requester.downloadPhCertificateFile(
          this.agro_exporter_id,
          this.packing_house_id,
          packing_house_certification.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          packing_house_certification.certificate_filename
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      packing_house_certification.downloading_certificate = false;
    },
    expiredAt(packing_house_certification) {
      let days = this.daysUntilExpirationDate(
        packing_house_certification.expiration_date
      );

      if (days > 0) {
        return `<span>
            <i class="fa-solid fa-circle-check text-green-500"></i>
            ${this.$t("labels.days", { days: this.numberWithPrecision(days) })}
            </span>`;
      } else {
        return `
            <span class="text-red-500">
            <i class="fa-solid fa-triangle-exclamation text-red-500"></i>
            ${this.$t("labels.expired_date")}
            </span>`;
      }
    }
  }
};
</script>
